module.exports = __webpack_public_path__ + "static/img/qyjB-CnZLE4sh.5bcf560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/qyjB-CnZLE4sh.png
// module id = 1/Hp
// module chunks = 16